import { Link } from 'react-router-dom';
import { hotRecommendations } from '@/mocks/home';

export default function HotRecommendations() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">大家都在看的热门内容</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {hotRecommendations.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-0 left-0">
                  <span className="inline-block px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-br-lg">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    <span className="text-white text-sm font-medium">{item.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="font-medium text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-1">{item.category}</p>
            </Link>
          ))}
        </div>
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}